module.exports = __webpack_public_path__ + "img/cf247-logo.b4777757.png";